//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import countries from './countryList'
 export default {
    components: {  
    },
    data() {
       return { 
        countriesFind: {},
        selectIndex: 0,
        isShow: false,
        value: "",
        lang: ""
       }
    },
      created() {
        this.lang = window.localStorage.getItem("lang") || 'en'
         this.countriesFind = countries[this.lang]
         console.log(this.countriesFind)
        // let us = countries['zh'];
        // console.log(us)
      },
      computed:{
      
      },    
      methods: {
        onSearch (val)  {
            if (!val) {
                this.countriesFind = countries[this.lang]
                return
            }
            this.countriesFind = {}
            Object.keys(countries[this.lang]).forEach((key) => {
                console.log(countries[this.lang][key].name)
                if (countries[this.lang][key].name.toLowerCase().indexOf(val.toLowerCase()) > -1 || countries[this.lang][key].dialCode.toString().indexOf(val) > -1) {
                    this.countriesFind[key] = countries[this.lang][key]
                }
            })
        },
        onClear(){

        },
        open ()  {
            this.isShow = true;
        },
        selectItem(item, key) {
            this.selectIndex = item.code;
            let obj = {
                name: item.name,
                code: item.code,
                dialCode: item.dialCode,
                key: key
            }

            this.$emit('getName', obj)
            this.isShow = false
        }
      }
   }
 


// WEBPACK FOOTER //
// ./src/components/areaList.vue